export default __webpack_public_path__ + "static/media/velo512.518a3f37.png";